export default "__VITE_ASSET__N1EtirPz__"